<ion-header>
  <ion-toolbar>
    <c-button slot="end" type="secondary" size="small" [iconOnly]="true" [icon]="faXmark" (action)="onClose()" />
    <ion-title>{{ label }}</ion-title>
  </ion-toolbar>
  @if (enableSearch) {
    <ion-toolbar>
      <ion-searchbar [placeholder]="'common.search' | transloco" (ionInput)="searchChange($event)"></ion-searchbar>
    </ion-toolbar>
  }
</ion-header>
<ion-content>
  @for (item of filteredOptions; track trackItems($index, item)) {
    <ion-item
      [class.selected]="isSelected(item.value)"
      (click)="onSelect(item.value)"
      [attr.data-test-id]="'select-modal-component.' + item.value + '.ion-item'">
      {{ item.label }}
      @if (isSelected(item.value)) {
        <c-icon slot="end" [icon]="checkIcon" color="primary" />
      }
    </ion-item>
  }

  @if (filteredOptions?.length === 0) {
    <ion-item class="no-results">
      {{ noResultsLabel | transloco }}
    </ion-item>
  }
</ion-content>
